// components/misc/CustomNode.js
import React from "react";
import { Handle, Position } from "reactflow";

const CustomNode = ({ data, isConnectable }) => {
  const handleStyle = {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    transition: "all 0.2s ease-in-out",
    transformOrigin: "center",
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
  };

  const sourceHandleStyle = {
    ...handleStyle,
    right: "-4px",
    backgroundColor: "black",
  };

  const targetHandleStyle = {
    ...handleStyle,
    left: "-4px",
    backgroundColor: "black",
  };

  const handleHoverStyle = {
    transform: "translateY(-50%) scale(3.5)",
  };

  return (
    <div className="relative rounded-md border border-gray-800 bg-white px-4 py-2 text-gray-900">
      <Handle
        type="source"
        position={Position.Right}
        id="a"
        isConnectable={isConnectable}
        style={sourceHandleStyle}
        className="hover:scale-[3]"
        onMouseOver={(e) => {
          e.target.style.transform = handleHoverStyle.transform;
        }}
        onMouseOut={(e) => {
          e.target.style.transform = handleStyle.transform;
        }}
      />
      <Handle
        type="target"
        position={Position.Left}
        id="b"
        isConnectable={isConnectable}
        style={targetHandleStyle}
        className="hover:scale-[3]"
        onMouseOver={(e) => {
          e.target.style.transform = handleHoverStyle.transform;
        }}
        onMouseOut={(e) => {
          e.target.style.transform = handleStyle.transform;
        }}
      />
      <div>{data.label}</div>
    </div>
  );
};

export default CustomNode;
